import { postRoute } from "../client"

export const attachReferralRoute = postRoute<{ success: true }>("/api/engagement/referral")
